import styled from 'styled-components';
import { COLORS } from '../../../../constants/radar';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: Arial, sans-serif;
`;

export const Label = styled.span`
  color: ${COLORS.BREADCRUMB.TEXT};
  font-size: 14px;
  font-weight: 500;
`;

export const PathContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const Separator = styled.span`
  color: ${COLORS.BREADCRUMB.TEXT};
  font-size: 14px;
  margin: 0 4px;
`;

export const Item = styled.span`
  font-size: 14px;
  color: ${props => props.$isActive ? COLORS.BREADCRUMB.ACTIVE : COLORS.BREADCRUMB.TEXT};
  font-weight: ${props => props.$isActive ? 'bold' : 'normal'};
  cursor: ${props => props.$isClickable ? 'pointer' : 'default'};
  transition: color 0.2s ease;

  ${props => props.$isClickable && `
    &:hover {
      color: ${COLORS.BREADCRUMB.ACTIVE};
    }
  `}
`;
